<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="winningScientificCompetition"
        :is-no-changes="isNoChanges"
        @save="saveWinningScientificCompetition"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-2 overflow-auto"
        >
          <WorkTitleCard :title="this.workTypeRusName(workTypeName.WinningScientificCompetition)" />

          <AuthorsCard
            class="mt-4"
            title="Участник"
            :selected-item.sync="winningScientificCompetition.commonWork.authors"
            :is-show-mode="isShowMode"
            hide-share
            hide-not-found-author
            @updateInvalid="updateAuthorsInvalid"
          />

          <WinningScientificCompetitionCard
            class="mt-4"
            title="Основная информация"
            :is-show-mode="isShowMode"
            :selected-item.sync="winningScientificCompetition"
            @updateInvalid="updateWinningScientificCompetitionInvalid"
          />

          <CommentCard
            v-if="Boolean(winningScientificCompetition.commonWork.comment)"
            class="mt-4"
            :comment="winningScientificCompetition.commonWork.comment"
          />

          <CreatorCard :creator-name="winningScientificCompetition.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { winningScientificCompetitionApi } from '@/api'
import TitleCard from '@/components/Works/elements/TitleCard'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { workListHeight } from '@/mixins/workListHeight'
import { dictionaryNames, workMode, workTypeName } from '@/scripts/consts'
import WorkTitleCard from '@/components/Works/elements/WorkTitleCard.vue'
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import { WinningScientificCompetition } from '@/models/works/WinningScientificCompetition'
import WinningScientificCompetitionCard from '@/components/Works/WinningScientificCompetition/WinningScientificCompetitionCard.vue'

export default {
  name: 'WinningScientificCompetitionPage',

  metaInfo() {
    return {
      title: this && this.workTypeRusName(workTypeName.WinningScientificCompetition)
    }
  },

  components: {
    WinningScientificCompetitionCard,
    CreatorCard,
    WorkTitleCard,
    CommentCard,
    AuthorsCard,
    TitleCard
  },

  mixins: [workListHeight],

  created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    this.getData()
  },

  data: () => ({
    winningScientificCompetition: new WinningScientificCompetition(),
    dataLoaded: false,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    winningScientificCompetitionInvalid: false,
    authorsInvalid: false,
    saveBtnLoading: false,
    isNoChanges: true
  }),

  computed: {
    workTypeName() {
      return workTypeName
    },
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),

    invalid() {
      return this.winningScientificCompetitionInvalid || this.authorsInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries']),
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      if (!this.isShowMode) await this.getDictionaries([dictionaryNames.Year, dictionaryNames.Reward])
      await this.getWorkTypes()
      await this.getWinningScientificCompetition()
      this.dataLoaded = true
      this.isNoChanges = true
    },

    async getWinningScientificCompetition() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = this.$route.params?.id ? await winningScientificCompetitionApi.get(this.$route.params?.id) : null
          if (data) this.winningScientificCompetition = new WinningScientificCompetition(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async saveWinningScientificCompetition(isThrowError = false) {
      try {
        this.saveBtnLoading = true

        if (!this.winningScientificCompetition.id)
          this.winningScientificCompetition.commonWork.workType = this.workTypeByName(
            workTypeName.WinningScientificCompetition
          )

        const body = this.winningScientificCompetition.getForAPI()

        const data = this.winningScientificCompetition.id
          ? await winningScientificCompetitionApi.update(body)
          : await winningScientificCompetitionApi.create(body)

        if (!this.winningScientificCompetition.id)
          await this.$router.replace('/works/winningScientificCompetition/edit/' + data.id)

        this.winningScientificCompetition = new WinningScientificCompetition(data)
        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения работы')
        if (isThrowError) throw new Error('Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    updateAuthorsInvalid(val) {
      this.authorsInvalid = val
      this.isNoChanges = false
    },

    updateWinningScientificCompetitionInvalid(val) {
      this.winningScientificCompetitionInvalid = val
      this.isNoChanges = false
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },

  provide: function () {
    return {
      saveWork: this.saveWinningScientificCompetition
    }
  }
}
</script>

<style scoped></style>
